import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { City } from "@models/city";
import { deleteRequest, fetchRequest } from "@actions/city";
import CitiesTable from "@components/cities/Table";
import TableRenderer from "@hocs/TableRenderer";
import CityForm from "@components/cities/Form";
import { FormattedMessage } from "react-intl";
import { Button, Card, Col, Row } from "antd";
import { getCitiesList } from "@reducers/city";
import SearchCitiesComponent from "@components/cities/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: City[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class CitiesIndexPage extends React.Component<AllProps> {
  deleteCity = (item: City): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/cities/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_city"
                defaultMessage={`Create City`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card bordered={false} className={`page-table-header search-part`}>
            <SearchCitiesComponent search={search} />
          </Card>

          <CitiesTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteCity}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ cities }: ApplicationState) => ({
  loading: cities.loading,
  errors: cities.errors,
  data: getCitiesList(cities),
  count: cities.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(CitiesIndexPage));
